/* eslint-disable react/prop-types */
import React, { useEffect, useRef, useState } from 'react';
import {
  Pagination,
  PageSize,
  Results as ResultCount,
} from '@uhg-abyss/web/ui/Pagination';
import { Grid } from '@uhg-abyss/web/ui/Grid';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { usePagination } from '@uhg-abyss/web/hooks/usePagination';

export type PaginationHookResult = ReturnType<typeof usePagination>;

// eslint-disable-next-line react/prop-types
export const PaginationComp = ({
  totalcount,
  numberofrecordsPerpags,
  handlePageEvent,
  pageSizeEvent,
  variant,
  showPageSize,
  pageNo,
  externalHook,
}: {
  totalcount: number;
  numberofrecordsPerpags: number;
  handlePageEvent: (page: number) => void;
  pageSizeEvent: (size: number) => void;
  variant: string;
  showPageSize: string;
  pageNo: number;
  externalHook?: PaginationHookResult;
}) => {
  const pageSizeOptions = [10, 15, 20, 50];
  const [pageSize, setPageSize] = useState(numberofrecordsPerpags);

  const internalHook = usePagination({
    pages: Math.ceil(totalcount / numberofrecordsPerpags),
    start: pageNo,
  });

  const {
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    state,
    ...paginationProps
  } = externalHook ?? internalHook;

  const { currentPage } = state;

  const isMountedPageRef = useRef(false);
  useEffect(() => {
    if (!isMountedPageRef.current) { isMountedPageRef.current = true; return; }
    if (externalHook) return; // parent watches currentPage when sharing state
    // eslint-disable-next-line no-param-reassign
    handlePageEvent(currentPage);
  }, [currentPage]);

  const isMountedSizeRef = useRef(false);
  useEffect(() => {
    if (!isMountedSizeRef.current) { isMountedSizeRef.current = true; return; }
    // eslint-disable-next-line no-param-reassign
    pageSizeEvent(pageSize);
  }, [pageSize]);

  return (
    <React.Fragment>
      {/* <h1>{currentPage}</h1> */}
      <Layout.Stack alignItems="left">
        {/* aria-hidden: our live region in Search.tsx is the single announcer (CP 4.15) */}
        <div style={{ marginTop: '4px', marginBottom: '4px' }} aria-hidden="true">
          <ResultCount
            // additionalText="(Can insert extra text here)"
            {...paginationProps}
            resultsTotalCount={totalcount}
            pageSize={pageSize}
            css={{
              'abyss-pagination-results-root': {
                fontWeight: 'bold',
              },
              'abyss-pagination-results-text': {
                margin: '0px',
              },
            }}
          />
        </div>
        <div style={{ margin: '2px' }}>
          <Grid>
            {showPageSize === 'true' ? (
              <Grid.Col>
                <PageSize
                  pageSizeOptions={pageSizeOptions}
                  pageSize={pageSize}
                  setPageSize={setPageSize}
                  css={{
                    'abyss-pagination-page-size-root': {
                      fontWeight: 'bold',
                    },
                  }}
                />
              </Grid.Col>
            ) : (
              ``
            )}
            <Grid.Col>
              <Pagination
                {...paginationProps}
                canPreviousPage={canPreviousPage}
                canNextPage={canNextPage}
                variant={variant as any}
                goToPage={(paginationProps as any).goToPage}
                previousPage={previousPage}
                nextPage={nextPage}
              />
            </Grid.Col>
          </Grid>
        </div>
      </Layout.Stack>
    </React.Fragment>
  );
};
